<template>
  <div class="container-fluid">
    <div v-if="!isLoading">
      <b-row>
        <b-col>
          <h2>Gestion des postes</h2>
          <div>
            <Alert v-if="configurationInfo.nb_free_licence < 0" type="danger" :title="titleUninstallErrorAlert" :subtitle="subtitleUninstallErrorAlert"/>
            <div>
              <b-row class="items-list d-flex flex-wrap">
                <b-col cols="12" v-for="endpoint in endpointData" :key="endpoint.id">
                  <div href="#" class="items-list-item max-width">
                    <div class="item-container">
                      <div class="w-100 px-2">
                        <b-row class="my-1">
                          <b-col class="d-flex align-items-center justify-content-between computers">
                            <div>
                              <i class="fa fa-desktop" />
                              <b class="mx-2">{{ endpoint.display_name || endpoint.computer_name }}</b>
                              <i class="fa fa-pencil-square-o" style="cursor: pointer;" @click="() => openDisplayNameEditModal(endpoint)" />
                            </div>
                            <div v-if="endpoint.first_seen">
                              <span class="ob1-capsule">Installé le {{ moment(endpoint.first_seen).format('DD/MM/YYYY') }} à {{ moment(endpoint.first_seen).format('HH:mm') }}</span>
                            </div>
                            <div v-else>
                              <span class="ob1-capsule ob1-capsule-disabled">Pas encore installé</span>
                            </div>
                            <Link :action="() => showUninstallToken(endpoint)" text="Désinstaller le poste"/>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <Link :action="goToInstallation" text="Installer un nouveau poste" customClass="mt-2" />
            </div>
          </div>
        </b-col>
      </b-row>
			<b-row class="mt-4">
        <div>
					<h2>Gestion des collaborateurs</h2>
				</div>
        <div id="collab-table">
          <b-col cols="12" v-for="collaborator in collaborators" :key="collaborator.id">
            <div href="#" class="items-list-item max-width">
              <div class="item-container">
                <div class="w-100 px-2">
                  <b-row class="my-1">
                    <b-col class="d-flex align-items-center justify-content-between collaborators">
                      <div>
                        {{ collaborator.lastname | upper }} {{ collaborator.firstname | capitalize }}
                      </div>
                      <div>
                        <span class="ob1-capsule">Lien envoyé le {{ moment(collaborator.installation_link_sent_at).format('DD/MM/YYYY') }}</span>
                      </div>
                      <div>
                        <Link :action="() => resendCollabMail(collaborator)" text="Renvoyer" customClass="text-right" />
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
          <Alert v-if="collaborators.length > 0" type="info" title="Le lien reçu est valide 48 heures après la date d'envoi au collaborateur." />
          <Link :action="sendCollabMail" text="Ajouter un collaborateur" customClass="mt-2" />
        </div>
      </b-row>
      <b-row v-if="agentAlert.show" class="mt-4">
        <NeutralAlert icon="shield" :title="agentAlert.title" button="Modifier vos licences" :action="goToModifyLicences" customClass="mt-2"/>
      </b-row>
      <Link :action="goToInstallation" text="Comment installer un nouveau poste" customClass="mt-2" />
      <b-row class="mt-4">
        <div>
          <h2>Code d'installation</h2>
          <Alert type="info" title="Votre code d’installation est unique et utilisable au moment de l’installation sur l’ensemble de vos postes." />
          <div class="mb-2">
            <b>Code :</b>
            <span class="ob1-capsule ob1-capsule-disabled ml-2">{{ token }}</span>
          </div>
          <div v-if="!isInstallTokenCopied" @click.stop.prevent="copyToClipboard('install')" style="cursor: pointer;">
            <span>
              <i class="fa fa-files-o mr-1" />
              Copier le code d'installation
            </span>
          </div>
          <div v-else>
            <span>
              <i class="fa fa-check-circle-o mr-1" />
              Copié dans le presse-papier
            </span>
          </div>
          <input type="hidden" id="install-token-input" :value="token">
        </div>
      </b-row>
    </div>
    <div class="d-flex justify-content-center" v-else>
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <b-modal id="modal-uninstall-token" ref="modal-uninstall-token" size="lg" hide-header hide-footer>
      <div class="d-flex align-items-center justify-content-between">
        <h4>Code de désinstallation</h4>
        <i class="fa fa-times" @click="$bvModal.hide('modal-uninstall-token')" style="cursor: pointer;"/>
      </div>
      <b-form>
        <b-row>
          <b-col class="mb-4">
            <p>Afin de désinstaller Cyberprotection sur le poste <b>{{ selectedComputer.computer_name }}</b>, veuillez utiliser le code suivant :</p>
            <span class="code">{{ uninstallToken }}</span>
            <div class="mt-2">
              <span class="btn copy-btn ml-auto" @click.stop.prevent="copyToClipboard('uninstall')">
                <i class="fa fa-files-o mr-1" />Copier le code de désinstallation
              </span>
              <span class="mr-3 text-success" v-if="isUninstallTokenCopied">
                <i class="fa fa-check-circle fa-2x text-success" /> Copié dans le presse-papier
              </span>
            </div>
            <input type="hidden" id="uninstall-token-input" :value="uninstallToken">
          </b-col>
        </b-row>
        <div class="d-flex">
          <div class="mr-2">
            <b-button @click="$bvModal.hide('modal-uninstall-token')" variant="info">Fermer</b-button>
          </div>
          <b-button 
            @click="remoteUninstall" 
            variant="danger" 
            :disabled="isAdmin || isLoadingUninstall"
          >
            <b-spinner small v-if="isLoadingUninstall" class="mr-1"></b-spinner>
            <i v-else class="fa fa-trash-o mr-1"></i>
            Désinstaller à distance
          </b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal id="modal-add-collab" ref="modal-add-collab" size="lg" hide-header hide-footer>
      <div class="d-flex align-items-center justify-content-between">
        <h4>{{ isResend ? 'Renvoyer le lien à un collaborateur' : 'Ajouter un collaborateur' }}</h4>
        <i class="fa fa-times" @click="$bvModal.hide('modal-add-collab')" style="cursor: pointer;"/>
      </div>
      <b-form>
        <div class="form-group">
          <input type="text" id="lastname" data-ob1-component="FormControlEmpty" :class="`form-control${collaboratorForm.lastname.length === 0 ? ' form-control-empty' : ''}${error.lastname.show ? ' is-invalid' : ''}`" aria-labelledby="label-lastname" ref="lastname" v-model.trim="collaboratorForm.lastname" required>
          <label id="label-lastname" class="form-control-placeholder" for="lastname">Nom</label>
          <Alert v-if="error.lastname.show" :title="error.lastname.message" type="danger" />
        </div>
        <div class="form-group">
          <input type="text" id="firstname" data-ob1-component="FormControlEmpty" :class="`form-control${collaboratorForm.firstname.length === 0 ? ' form-control-empty' : ''}${error.firstname.show ? ' is-invalid' : ''}`" aria-labelledby="label-firstname" ref="firstname" v-model.trim="collaboratorForm.firstname" required>
          <label id="label-firstname" class="form-control-placeholder" for="firstname">Prénom</label>
          <Alert v-if="error.firstname.show" :title="error.firstname.message" type="danger" />
        </div>
        <div class="form-group">
          <input type="text" id="email" data-ob1-component="FormControlEmpty" :class="`form-control${collaboratorForm.email.length === 0 ? ' form-control-empty' : ''}${error.email.show ? ' is-invalid' : ''}`" aria-labelledby="label-email" ref="email" v-model.trim="collaboratorForm.email" required>
          <label id="label-email" class="form-control-placeholder" for="email">Adresse email</label>
          <Alert v-if="error.email.show" :title="error.email.message" type="danger" />
        </div>
        <div class="form-group">
          <MazPhoneNumberInput class="maz-custom" ref="phone" :translations="translations" :default-phone-number="collaboratorForm.phone" default-country-code="FR" v-model.trim="collaboratorForm.phone" @update="phoneResults = $event" />
          <Alert v-if="error.phone.show" :title="error.phone.message" type="danger" />
        </div>
        <b-button variant="info" @click="storeCollaborator" :disabled="isLoadingAddCollab">
          <b-spinner small v-if="isLoadingAddCollab" class="mr-1"></b-spinner>
          Valider
        </b-button>
      </b-form>
    </b-modal>
    <b-modal id="modal-edit-display-name" ref="modal-edit-display-name" size="lg" hide-header hide-footer>
      <div class="d-flex align-items-center justify-content-between">
        <h4>Modifier le nom d'un agent</h4>
        <i class="fa fa-times" @click="$bvModal.hide('modal-edit-display-name')" style="cursor: pointer;"/>
      </div>
      <b-form>
        <div class="form-group">
          <input type="text" id="display_name" data-ob1-component="FormControlEmpty" :class="`form-control${display_name.length === 0 ? ' form-control-empty' : ''}${display_name.length === 0 ? ' is-invalid' : ''}`" aria-labelledby="label-display_name" ref="display_name" v-model.trim="display_name" required >
          <label id="label-display_name" class="form-control-placeholder" for="display_name">Nom</label>
          <Alert v-if="display_name.length === 0" title="Merci de remplir ce champ." type="danger" />
        </div>
        <b-button variant="info" @click="submitEditDisplayName" :disabled="isLoadingEditDisplayName">
          <b-spinner small v-if="isLoadingEditDisplayName" class="mr-1"></b-spinner>
          Valider
        </b-button>
      </b-form>
    </b-modal> 
  </div>
</template>

<script>
import { MazPhoneNumberInput } from "maz-ui";
import "maz-ui/lib/css/base.css";
import "maz-ui/lib/css/maz-phone-number-input.css";
import Loader from "@/components/Loader/Loader";
import Alert from "@/components/Alert/Alert";
import NeutralAlert from "@/components/Alert/NeutralAlert";
import Link from "@/components/Link/Link";
import moment from 'moment';
import logger from "@/utils/func/logger";
import {isMobile} from '@/core/screenHelper';
import auth from "@/utils/func/auth";

export default {
  name: "Gestion",
  components: {
    MazPhoneNumberInput,
    Loader,
    Alert,
    NeutralAlert,
    Link,
  },
  data() {
    return {
      moment: moment,
      isAdmin: auth.isAdmin(),
      mailRegex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, //eslint-disable-line no-useless-escape
      isResend: false,
      isLoading: false,
      isMobile : false,
      isLoadingUninstall: false,
      isInstallTokenCopied: false,
      isUninstallTokenCopied: false,
      endpointData : [],
      configurationInfo: {},
      uninstallToken: null,
      token: null,
      selectedComputer: {
        computer_name: null
      },
      collaborators: [],
      collaboratorForm: {
				lastname: '',
				firstname: '',
				email: '',
				phone: '',
			},
      error: {
				lastname: {
					show: false,
					message: '',
				},
				firstname: {
					show: false,
					message: '',
				},
				email: {
					show: false,
					message: '',
				},
				phone: {
					show: false,
					message: '',
				},
			},
      paramRequest: {
        page: 1,
        perPage: 100
      },
      totalItems: 0,
      isLoadingAddCollab: false,
      translations: {
				countrySelectorLabel: 'Code pays',
				countrySelectorError: 'Choisir un pays',
				phoneNumberLabel: 'Numéro de téléphone',
				example: 'Exemple :',
				countrySelectorSearchPlaceholder: 'Rechercher un pays',
			},
      agentAlert: {
        show: false,
        title: null
      },
      selectedAgentToEdit: {
        computer_name: '',
        first_seen: '',
        id: null,
        display_name: '',
        uninstall_token: '',
      },
      display_name: '',
      isLoadingEditDisplayName: false,
    }
  },
  computed: {
    adminOhpEuid() {
      return this.$store.state.configuration.adminOhpEuid || '';
    },
    titleUninstallErrorAlert() {
      return `Suite à la réduction du nombre de licences comprises dans votre offre, si la désinstallation de ${this.configurationInfo.nb_free_licence * -1} agent${this.configurationInfo.nb_free_licence < -1 ? 's' : ''} n'est pas effectuée le ${this.configurationInfo.uninstall_at}, ${this.configurationInfo.nb_free_licence < -1 ? "les agents suivants seront automatiquement désinstallés" : "l'agent suivant sera automatiquement désinstallé"} à distance :`;
    },
    subtitleUninstallErrorAlert() {
      const l = [];
      this.configurationInfo.list_licences_to_uninstall.forEach(licence => {
        l.push(licence.computer_name);
      });
      return l.join(', ');
    },
  },
  filters: {
    upper(s) {
      return s ? s.toUpperCase() : '';
    },
    capitalize(s) {
      return s && s.length > 0 ? Array.from(s)[0].toUpperCase() + s.slice(1) : '';
    },
  },
  mounted() {
    this.$store.commit('configuration/updateAdminOhpEuid', this.$route.query.ohpEuid);
    this.getUninstallToken();
    this.getConfigurationsInfo();
    this.getCollaborators();
    this.getToken();
    this.isMobile = isMobile();
  },
  methods: {
    getToken() {
      const data = {
        adminOhpEuid: this.adminOhpEuid || this.$route.query.euid,
      };

      this.isLoading = true;
      this.$store.dispatch('tenant/getCustomerTokenId', data)
        .then((res) => {
          logger.log('Success getCustomerTokenId', res);
          this.token = res.editor_customer_token_id;
          const showFeedback = res.nb_agent == 0;
          this.$store.commit('configuration/updateShowFeedBackInstall', showFeedback);
          this.isLoading = false;
        })
        .catch((err) => {
          logger.error('Err call getCustomerTokenId', err);
          this.isLoading = false;
        });
    },
    copyToClipboard (type) {
      let textToCopy =  document.querySelector(`#${type}-token-input`);

      textToCopy.setAttribute('type', 'text');
      textToCopy.select();

      try {
        document.execCommand('copy');
        if (type === 'install') {
          this.isInstallTokenCopied = true;
        } else {
          this.isUninstallTokenCopied = true;
        }

        setTimeout(() => {
          if (type === 'install') {
            this.isInstallTokenCopied = false;
          } else {
            this.isUninstallTokenCopied = false;
          }
        }, 5000);
      } catch (err) {
        logger.error('Err call copyToClipboard', err);
      }

      /* unselect the range */
      textToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    storeCollaborator() {
			let exit = false;
			if (this.collaboratorForm.lastname.length === 0) {
				this.error.lastname.show = true;
				this.error.lastname.message = "Merci de remplir ce champ.";
				exit = true;
			}
			if (this.collaboratorForm.firstname.length === 0) {
				this.error.firstname.show = true;
				this.error.firstname.message = "Merci de remplir ce champ.";
				exit = true;
			}
			if (this.collaboratorForm.email.length === 0) {
				this.error.email.show = true;
				this.error.email.message = "Merci de remplir ce champ.";
				exit = true;
			} else if (!this.mailRegex.test(this.collaboratorForm.email)) {
				this.error.email.show = true;
				this.error.email.message = "Le format de ce champ n'est pas valide. Vérifiez votre saisie.";
				exit = true;
			}
			if (!this.collaboratorForm.phone) {
				this.error.phone.show = true;
				this.error.phone.message = "Merci de remplir ce champ.";
				exit = true;
			} else if (!this.phoneResults.isValid) {
				this.error.phone.show = true;
				this.error.phone.message = "Le format de ce champ n'est pas valide. Vérifiez votre saisie.";
				exit = true;
			}
			if (exit) {
				return;
			}

			this.isLoadingAddCollab = true;
			this.$store.dispatch('user/storeCollaborator', this.collaboratorForm)
				.then((res) => {
					logger.log('SUCCESS storeCollaborator', res);
					this.isLoadingAddCollab = false;
					this.collaborators = res.collaborators;
					this.$bvModal.hide('modal-add-collab');
					this.collaboratorForm.lastname = '';
					this.collaboratorForm.firstname = '';
					this.collaboratorForm.email = '';
					this.collaboratorForm.phone = '';
          this.$toasted.success('Collaborateur ajouté avec succès.');
				})
				.catch((err) => {
					logger.error('Err call storeCollaborator', err);
					this.isLoadingAddCollab = false;
				});
		},
    getCollaborators() {
      const data = {
        adminOhpEuid: this.adminOhpEuid,
      };
			this.$store.dispatch('user/getCollaborators', data)
				.then((res) => {
					logger.log('SUCCESS getCollaborators', res);
					this.collaborators = res.collaborators;
					this.isLoadingAddCollab = false;
				})
				.catch((err) => {
					logger.error('Err call getCollaborators', err);
					this.isLoadingAddCollab = false;
				});
		},
    getUninstallToken() {
      this.isLoading = true;

      // Configure Request parameter
      // this.paramRequest.page = this.currentPage;
      // this.paramRequest.perPage = this.perPage;
      this.paramRequest.adminOhpEuid = this.adminOhpEuid;

      this.$store.dispatch('agent/getAgentsUninstallToken', this.paramRequest)
        .then((res) => {
          logger.log('SUCCESS getAgentsUninstallToken', res);
          this.endpointData = res.data;
          this.totalItems = res.total;
          this.isLoading = false;
        })
        .catch((err) => {
          logger.error('Err call getAgentsUninstallToken', err);
          this.isLoading = false;
        });
    },
    getConfigurationsInfo() {
      const data = {
        adminOhpEuid: this.adminOhpEuid,
      };

      this.isLoading = true;
      this.$store.dispatch('configuration/getConfigurationsInfo', data)
          .then((res) => {
            this.isLoading = false;
            logger.log('SUCCESS getConfigurationsInfo', res);
            this.configurationInfo = res;
            if (res.nb_free_licence >= 0) {
              this.agentAlert = {
                show: true,
                title: res.nb_free_licence > 0 ? `Votre option Cyber Protection vous permet d'installer encore ${res.nb_free_licence} nouveau${res.nb_free_licence > 1 ? 'x' : ''} poste${res.nb_free_licence > 1 ? 's' : ''}.` : "Votre option Cyber Protection ne vous permet plus d'installer de nouveaux postes."
              };
            }
          })
          .catch((err) => {
            logger.error('Err call getConfigurationsInfo', err);
            this.isLoading = false;
          });
    },
    showUninstallToken(endpoint) {
      this.uninstallToken = endpoint.uninstall_token;
      this.selectedComputer = endpoint;
      this.$bvModal.show('modal-uninstall-token');
    },
    sendCollabMail() {
      if (this.isAdmin) {
        return;
      }
			this.$bvModal.show('modal-add-collab');
			this.isResend = false;
		},
		resendCollabMail(collaborator) {
      if (this.isAdmin) {
        return;
      }
			this.collaboratorForm.lastname = collaborator.lastname;
			this.collaboratorForm.firstname = collaborator.firstname;
			this.collaboratorForm.email = collaborator.email;
			this.collaboratorForm.phone = collaborator.phone;
			this.isResend = true;
			this.$bvModal.show('modal-add-collab');
		},
    goToInstallation() {
      if (this.isAdmin) {
        this.$router.push('/admin/installation?ohpEuid=' + this.$route.query.ohpEuid);
      } else {
        this.$router.push('/app/installation');
      }
    },
    goToModifyLicences() {
      window.open('https://boutiquepro.orange.fr/internet/options-internet/cyber-protection', '_blank');
    },
    remoteUninstall() {
      this.isLoadingUninstall = true;
      this.$store.dispatch('gestion/remoteUninstall', {id: this.selectedComputer.id})
        .then((response) => {
          this.isLoading = false;
          this.isLoadingUninstall = false;
          this.$bvModal.hide('modal-uninstall-token');
          this.$toasted.success(response.message);
          this.getUninstallToken();
          logger.log('SUCCESS remoteUninstall', response);
        })
        .catch((error) => {
          this.isLoading = false;
          this.isLoadingUninstall = false;
          this.$toasted.error(error.message);
          logger.error('Err call remoteUninstall', error);
        });
    },
    openDisplayNameEditModal(agent) {
      if (this.isAdmin) {
        return;
      }
      this.selectedAgentToEdit = agent;
      this.display_name = agent.display_name || agent.computer_name;
      this.$bvModal.show('modal-edit-display-name');
    },
    submitEditDisplayName() {
      this.isLoadingEditDisplayName = true;
      this.$store.dispatch('gestion/editAgentName', {id: this.selectedAgentToEdit.id, display_name: this.display_name})
        .then((res) => {
          logger.log('SUCCESS editAgentName', res);
          this.$bvModal.hide('modal-edit-display-name');
          for (let i = 0; i < this.endpointData.length; i++) {
            if (this.endpointData[i].id === this.selectedAgentToEdit.id) {
              this.endpointData[i].display_name = this.display_name;
              break;
            }
          }
          this.isLoadingEditDisplayName = false;
          this.display_name = '';
          this.$toasted.success('Nom de l\'agent modifié avec succès.');
        })
        .catch((err) => {
          this.isLoadingEditDisplayName = false;
          logger.error('Err call editAgentName', err);
        });
    }
  },
  watch: {
    'collaboratorForm.lastname'() {
			this.error.lastname.show = false;
			this.error.lastname.message = '';
		},
		'collaboratorForm.firstname'() {
			this.error.firstname.show = false;
			this.error.firstname.message = '';
		},
		'collaboratorForm.email'() {
			this.error.email.show = false;
			this.error.email.message = '';
		},
		'collaboratorForm.phone'() {
			this.error.phone.show = false;
			this.error.phone.message = '';
		},
  }
}
</script>

<style lang="css">
.separator--gray4 {
  background-color: #ccc !important;
}
.test {
  width: 100px;
}
.code {
  border-radius: 25px;
  background: #989898;
  padding: 7px;
  width: 50px;
  height: 5px;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-not-allowed {
  cursor: not-allowed;
}

.items-list-item {
  max-width: unset;
}

.alert-container {
  max-width: 665px !important;
  
  .ob1-alert-title {
    font-weight: 400;
  }
}

.computers,
.collaborators {
  .ob1-capsule {
    margin-left: 0;
  }
}

@media screen and (max-width: 540px) {
  .computers > div:nth-child(2) {
    display: none;
  }
}

@media screen and (max-width: 564px) {
  .collaborators > div:nth-child(2) {
    display: none;
  }
}

.maz-input--primary.is-focused.maz-input--primary,
.maz-input--primary.is-focused.maz-input--primary:focus,
.maz-input--primary.is-focused.maz-input--primary:hover {
  border-color: #000;
}

.maz-custom {
  padding-top: 1.375rem;

  & > * {
    transition-duration: 0.2s;
  }

  &:focus-within {
    .maz-select.country-selector  {
      .maz-input {
        border-bottom: 0.125rem solid;
      }
    }

    .maz-input.input-phone-number {
      border-bottom: 0.125rem solid;
    }
  }
  
  .maz-select.country-selector  {
    .maz-input {
      border: none;
      border-bottom: 0.0625rem solid;
      border-radius: unset;
      .maz-input__icon path.arrow {
        fill: black;
      }
      .maz-input__label {
        color: black;
      }
    }
  }

  .maz-input.input-phone-number {
    border: none;
    border-bottom: 0.0625rem solid;
    border-radius: unset;
    max-width: 18.25rem;
    
    .maz-input__label {
      color: black;
    }
  }
}

#modal-add-collab {
  .modal-dialog {
    width: 570px;
  }
}

#modal-add-collab, #modal-uninstall-token {
  .modal-dialog {    
    .modal-content {
      display: flex;
      min-height: unset;
      padding: 2.8125rem;
      
      button.btn.btn-info {
        float: right;
      }
    }
  } 
}
</style>